import { render, staticRenderFns } from "./ResultsTemplate.vue?vue&type=template&id=fc8e8cde"
import script from "./ResultsTemplate.vue?vue&type=script&lang=js"
export * from "./ResultsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports